import { atom } from 'jotai';
export const disableQuickPreviewAtom = atom(false);
